export type Enum<E> = Record<string, E | string> & Record<number, string>;

export function enumToDictionary<E>(enumType: Enum<E>) {
  return Object.values(enumType)
    .filter(x => typeof (x) !== 'string')
    .map(x => ({
      key: x as E,
      value: enumType[x as unknown as number].toString()
    }));
}
